import React, { useState, useEffect } from 'react';
import { toast } from "react-hot-toast";
import { useParams, useLocation, useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSignupData } from "../../redux/slices/authSlice";
import { employeeSignUp, signUp } from "../../services/operations/authAPI";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { HiMiniBuildingOffice2 } from "react-icons/hi2";
import { FaUser } from "react-icons/fa";
import "./signupp.css";

function Signup() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [token,setToken]=useState(false)

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        company: "",
        remember: false,
    });

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordConditions, setPasswordConditions] = useState({
        length: false,
        lettersAndNumbers: false,
        specialCharacter: false,
    });

    // ✅ Get email from query params and autofill
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const emailFromUrl = params.get("email");
        const companyFromUrl = params.get("company");
        if (emailFromUrl) {
            setToken(true)
            setFormData((prevData) => ({
                ...prevData,
                email: emailFromUrl,
                company: companyFromUrl,
            }));
        }
    }, [location.search]);

    const { firstName, lastName, email, password, confirmPassword, company, remember } = formData;

    const handleOnChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;

        setFormData((prevData) => ({
            ...prevData,
            [name === "rememberMe" ? "remember" : name]: val,
        }));

        if (name === "password") {
            setPasswordConditions({
                length: val.length >= 8,
                lettersAndNumbers: /[A-Za-z]/.test(val) && /\d/.test(val),
                specialCharacter: /[!@#$%^&*(),.?":{}|<>]/.test(val),
            });
        }
    };

    const handleOnSubmit = (e) => {
        e.preventDefault();

        if (!passwordConditions.length || 
            !passwordConditions.lettersAndNumbers || 
            !passwordConditions.specialCharacter) {
        toast.error("Password does not meet all the conditions.");
        return;
         }

        if (password !== confirmPassword) {
            toast.error("Passwords Do Not Match");
            return;
        }

        const signupData = { ...formData };
        dispatch(setSignupData(signupData));

        if (token) {
            dispatch(employeeSignUp({ ...formData}, navigate));
        } else {
            dispatch(signUp(signupData, navigate));
        }

        setFormData({
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            confirmPassword: "",
            company: "",
            remember: false,
        });
    };

    return (
        <div className="page-container">
            <div className="signup-form">
                <h3 className="signup-heading">Signup</h3>
                <form className="form" onSubmit={handleOnSubmit}>
                    <div className="flex-column"><label>Company Name</label></div>
                    <div className="inputForm">
                    <HiMiniBuildingOffice2 />
                        <input
                            className="input"
                            name="company"
                            type="text"
                            placeholder="Enter your Company Name"
                            required
                            value={company}
                            onChange={handleOnChange}
                        />
                    </div>

                    <div className="flex-column"><label>First Name</label></div>
                    <div className="inputForm">
                    <FaUser />
                        <input
                            className="input"
                            name="firstName"
                            type="text"
                            placeholder="Enter your First Name"
                            required
                            value={firstName}
                            onChange={handleOnChange}
                        />
                    </div>

                    <div className="flex-column"><label>Last Name</label></div>
                    <div className="inputForm">
                    <FaUser />
                        <input
                            className="input"
                            name="lastName"
                            placeholder="Enter your Last Name"
                            required
                            value={lastName}
                            onChange={handleOnChange}
                        />
                    </div>

                    <div className="flex-column"><label>Email</label></div>
                    <div className="inputForm">
                    <svg height="20" viewBox="0 0 32 32" width="20" xmlns="http://www.w3.org/2000/svg">
            <g id="Layer_3" data-name="Layer 3">
              <path d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"></path>
            </g>
          </svg>
                        <input
                            className="input"
                            name="email"
                            placeholder="Enter your Email"
                            type="email"
                            required
                            value={email}
                            onChange={handleOnChange}
                            readOnly={token}
                        />
                    </div>

                    <div className="flex-column"><label>Password</label></div>
                    <div className="inputForm">
                    <svg height="20" viewBox="-64 0 512 512" width="20" xmlns="http://www.w3.org/2000/svg">
            <path d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0"></path>
            <path d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0"></path>
          </svg>
                        <input
                            className="input"
                            name="password"
                            placeholder="Enter your Password"
                            type={showPassword ? "text" : "password"}
                            required
                            value={password}
                            onChange={handleOnChange}
                        />
                        <span className="eye-icon" onClick={() => setShowPassword((prev) => !prev)}>
                            {showPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                        </span>
                    </div>

                    <div className="password-requirements">
                        <p>Password must meet the following criteria:</p>
                        <ul>
                            <li>
                                At least 8 characters long{" "}
                                {passwordConditions.length ? (
                                    <FaCheckCircle color="green" />
                                ) : (
                                    <FaTimesCircle color="red" />
                                )}
                            </li>
                            <li>
                                Includes both letters and numbers{" "}
                                {passwordConditions.lettersAndNumbers ? (
                                    <FaCheckCircle color="green" />
                                ) : (
                                    <FaTimesCircle color="red" />
                                )}
                            </li>
                            <li>
                                Contains at least one special character{" "}
                                {passwordConditions.specialCharacter ? (
                                    <FaCheckCircle color="green" />
                                ) : (
                                    <FaTimesCircle color="red" />
                                )}
                            </li>
                        </ul>
                    </div>

                    <div className="flex-column"><label>Confirm Password</label></div>
                    <div className="inputForm">
                    <svg height="20" viewBox="-64 0 512 512" width="20" xmlns="http://www.w3.org/2000/svg">
            <path d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0"></path>
            <path d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0"></path>
          </svg>
                        <input
                            className="input"
                            name="confirmPassword"
                            placeholder="Confirm your Password"
                            type={showConfirmPassword ? "text" : "password"}
                            required
                            value={confirmPassword}
                            onChange={handleOnChange}
                        />
                        <span className="eye-icon" onClick={() => setShowConfirmPassword((prev) => !prev)}>
                            {showConfirmPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                        </span>
                    </div>

                    {password && confirmPassword && (
                        <div className="emoji-feedback">
                            {password === confirmPassword
                                ? "😊 Passwords match!"
                                : "😟 Passwords do not match!"}
                        </div>
                    )}

                    {/* <div className="flex-row">
                        <input
                            type="checkbox"
                            name="rememberMe"
                            checked={remember}
                            onChange={handleOnChange}
                        />
                        <label>Remember me</label>
                    </div> */}

                    <div className="centre-btn">
                        <button className="signup-button" type="submit">
                            Signup
                            <div className="arrow-wrapper">
                                <div className="arrow"></div>
                            </div>
                        </button>
                    </div>
                </form>
                <div className="login-link">
                    Already have an account?{" "}
                    <Link to="/Login">
                        <button className="signup-button">Log In</button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Signup;